export default "__VITE_ASSET__cSr6a33R__"